const en = {
  app: {
    title: 'DigestMed Dashboard',
    logoAlt: 'DigestMed logo',
  },
  header: {
    userMenu: 'User menu',
    logout: 'Log out',
    language: 'Language',
    languageMenu: 'Choose language',
  },
  login: {
    sso: 'Sign in with IAM (SSO)',
  },
  period: {
    label: 'Period',
    currentMonth: 'Current month',
    previousMonth: 'Previous month',
    currentQuarter: 'Current quarter',
    yearToDate: 'Year to date',
    last12Months: 'Last 12 months',
  },
  dashboard: {
    indicators: 'Indicators',
    loadingValue: 'Loading…',
    noDataYet: 'No data yet',
    loadReportsFailed: 'Failed to load reports',
  },
  reports: {
    tabsLabel: 'Reports tabs',
    viewTab: 'View reports',
    auditTab: 'Audit',
    selectReport: 'Select report',
    view: 'View',
    loading: 'Loading…',
    none: 'No reports available.',
    noPathConfigured: 'Selected report has no path configured.',
    loadFailed: 'Failed to load reports',
    frameTitle: 'Report: {{title}}',
  },
  report: {
    fallbackName: 'Report {{id}}',
    breadcrumb: 'Reports',
    back: 'Back to reports',
    notFound: 'Report not found',
    loadError: 'Could not load the report. Please try again later.',
    viewer: 'Report Viewer',
    loadingReport: 'Loading report…',
  },
  export: {
    button: 'Export',
    inProgress: 'Exporting…',
    failed: 'Export failed. Please try again.',
    noTables: 'The displayed report has no tables to export.',
    noCharts: 'The displayed report has no charts to export.',
    generatedAt: 'Generated: {{date}}',
    periodRange: '{{period}}: {{from}} – {{to}}',
    format: {
      pdf: 'PDF',
      xlsx: 'Excel (XLSX)',
      csv: 'CSV',
      png: 'Charts as PNG',
      pptx: 'Charts to PowerPoint',
    },
    formatHint: {
      pdf: 'The page as displayed',
      xlsx: 'One sheet per table',
      csv: 'One file per table',
      png: 'One image per chart',
      pptx: 'One slide per chart',
    },
  },
};

export default en;
